<template>
 <page>
  

  <head-nav :title="$t('language.page_newsletters')">
    <icon-button-hamburger slot="left"></icon-button-hamburger>
    <icon-button-home slot="right"></icon-button-home>
  </head-nav>


  <scroll-page :pull-reload="true">

    <list-newsletters/>

   </scroll-page>
  </page>
</template>

<script>

import Page from '../pages/Page';
import HeadNav from '../components/HeadNav';
import IconButtonHome from '../components/buttons/IconButtonHome';
import ListNewsletters from '../components/newsletters/ListNewsletters';
import ScrollPage from '../components/ScrollPage.vue';
import IconButtonHamburger from '../components/buttons/IconButtonHamburger';
 
export default {
  name: 'global-newsletters-page',
  data:function(){
    return{
    }
  },
  computed:{
  },
  components: {
    ListNewsletters,
    HeadNav,
    IconButtonHome,
    IconButtonHamburger,
    Page,
    ScrollPage,
  },
  methods:{
    
  },
  created(){
     
  },
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
